import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function getCampaignReviewData(token) {
  return axios.get(`/campaign-review/${token}/posts`)
}

export function approveReviewPost(token, postId, authorName) {
  return axios.post(`/campaign-review/${token}/posts/${postId}/approve`, {
    comment: { author_name: authorName }
  })
}

export function requestReviewPostChanges(token, postId, body, authorName) {
  return axios.post(`/campaign-review/${token}/posts/${postId}/request_changes`, {
    comment: { body, author_name: authorName }
  })
}

export function addReviewPostComment(token, postId, body, authorName) {
  return axios.post(`/campaign-review/${token}/posts/${postId}/comments`, {
    comment: { body, author_name: authorName }
  })
}
